import React from "react";

export default function SessionExpiryModal({ open, minutesLeft, onStay, onLogout }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full text-center">
        <h2 className="text-xl font-bold mb-2">Session Expiring Soon</h2>
        <p className="mb-4 text-gray-600">
          Your session will expire in <span className="font-semibold">{minutesLeft} minute{minutesLeft !== 1 ? 's' : ''}</span>.<br />
          Please save your work.
        </p>
        <div className="flex gap-4 justify-center mt-6">
          <button
            className="bg-[var(--primary-font)] hover:bg-[var(--secondary-font)] px-4 py-2 rounded font-medium"
            onClick={onLogout}
          >
            Log Out Now
          </button>
          <button
            className="bg-[var(--primary-font)] hover:bg-[var(--secondary-font)] text-white px-4 py-2 rounded font-medium"
            onClick={onStay}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
}
